import Vue from 'vue';
import Vuex from 'vuex';
import VuexReset from '@ianwalter/vuex-reset';

import Settings from './settings';
import Navigation from './navigation';
import UserSelections from './userSelections';
import Results from './results';
import Order from './order';
import Brands from './brands';
import Shopify from './shopify';
import Local from './local';
import Dev from '../../src-dev/store';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,

  plugins: [VuexReset()],

  modules: {
    settings: Settings,
    navigation: Navigation,
    userSelections: UserSelections,
    results: Results,
    order: Order,
    brands: Brands,
    shopify: Shopify,
    local: Local,
    dev: Dev,
  },
});
